<template>
  <div
                  v-if="localValue.type === 'textarea'"
                  :id="'localValue' + index"
                  class="relative"
                  :style="
                    'margin: ' + styles.margin.join('px ') + 'px;' +
                    'color:' + styles.color + ';'
                  "
                >
                  <div
                    class="text-sm font-semibold mb-2"
                    v-if="!hideLabels"
                    :style="
                      'text-align: ' + styles.text.textAlign + ';' +
                      'color: ' + styles.labelColor + ';'
                    "
                  >
                    {{ localValue.placeholder }}
                    <span
                      v-if="
                      localValue.mandatory === true ||
                      localValue.mandatory === 1 ||
                      localValue.mandatory === 'true'
                      "
                      style="color: red; font-weight: bold"
                      >*</span
                    >
                  </div>
                  <textarea
                    rows="3"
                    class="w-full border border-grey-300 resize-none rounded text-dark text-sm focus:outline-none"
                    :style="
                        'background:' + styles.backgroundColor + ';' +
                        'box-shadow:' + (styles.boxShadow ?? '') + ';' +

                        '--form-style-placeholder-color:' + styles.placeholderColor + ';' +
                        'font-family:' + (styles.text.fontFamily || '') + ';' +
                        'text-shadow:' + (styles.text.textShadow || '') + ';' +
                        'font-size:' + styles.text.fontSize + 'px;' +
                        'text-align:' + styles.text.textAlign + ';' +
                        'font-style:' + (styles.text.fontStyle || '') + ';' +
                        'font-weight:' + (styles.text.fontWeight || '') + ';' +
                        'letter-spacing:' + (styles.text.letterSpacing || '') + ';' +
                        'line-height:' + (styles.text.lineHeight || '') + ';' +
                        '-webkit-text-stroke-width:' + (styles.text.textStrokeWidth || '') + ';' +
                        '-webkit-text-stroke-color:' + (styles.text.textStrokeColor || '') + ';' +
                        'text-decoration-line:' + (styles.text.textDecorationLine || '') + ';' +
                        'color:' + styles.text.color + ';' +

                        'padding: ' + styles.padding.join('px ') + 'px;' +
                        'border-width:' + styles.border?.width.join('px ') + 'px;' +
                        'border-radius:' + styles.border?.radius.join('px ') + 'px;' +
                        'border-color:' + styles.border?.color.join(' ') + ';' +
                        'border-style:' + styles.border?.style.join(' ') + ';' +
                        styles.customStyles ?? ''
                    "
                    :placeholder="hideLabels ? localValue.placeholder : ''"
                  ></textarea>
                  <span
                    class="absolute"
                    v-if="
                      (localValue.mandatory === true ||
                      localValue.mandatory === 1 ||
                      localValue.mandatory === 'true') &&
                      hideLabels
                    "
                    :style="
                      'color: #ff0000; font-weight: bold; right: 16px;' +
                      'top:' + (styles.padding[0] ) + 'px;'
                    "
                    >*</span
                  >
                </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'FormTextArea',
  props: {
    value: {
      required: true,
    },
    index: {
      required: true,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    ...mapState({
      hideLabels: state => state.forms.hideLabels,
    }),
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hide() {
      this.localValue = '';
      this.localShown = false;
    },
    onTextChange(e) {
      console.log(e.target.innerText);
      this.localValue = e.target.innerText;
    },
  }
}
</script>
